export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./bk-bets-list.vue?vue&type=template&id=2b417319"


//////////////////
// WEBPACK FOOTER
// ./src/components/common/bk-bets-list.vue?vue&type=template&id=2b417319
// module id = A14K
// module chunks = 0